export default __webpack_public_path__ + "static/pragicts-secops-services-cisoaas-67d503a7d5ae947572cd0f95b2b5de58.jpg";